import React, { Component } from 'react';
import YesButton from '../../../../../common/button/answerButton/yesButton/yesButton';
import NoButton from '../../../../../common/button/answerButton/noButton/noButton';
import './question.scss';
class Question extends Component {

    state = {
        className : 'test-to-show nineth-test',
        attributes:{},
        automaticAnswer : false,
        symbol : null,
        startTime : null
    }

    componentDidMount(){
        // const userAnswers = this.props.userAnswers;
        const timeOut = this.props.timeOut;
        const timetoShow = this.props.timetoShow;
        let attributes = {};
        attributes.correct = this.props.correct;


        const {symbol, symbo2} = {...this.props}
        this.setState({symbol});
        let characters = [];
        for(let i=0; i<symbo2.toString().length; i++){
            characters[i] = symbo2.toString()[i];
        }
        document.querySelectorAll('.answer-buttons')
        console.log(characters);
        let index = 0;
        let timeInterval = setInterval(()=>{
            document.querySelector('.nineth-test .symbol-holder').innerHTML = characters[index];
            if(characters.length >= index +1){
                index ++;
            }
            else{
                document.querySelector('.nineth-test .symbol-holder').innerHTML = "+";
                setTimeout(function(){
                    document.querySelector('.testNineText').style.visibility = 'visible';
                },1000);
                document.addEventListener("keydown", this.showChar);
                document.addEventListener("keypress",this.addListeners);
                clearInterval(timeInterval);
                return;
            }
        },1000);

        

        // let characters = document.querySelectorAll('.eigth-test .symbol-holder .character');
        // for(let i=0; i<characters.length; i++){
        //     Object.assign(characters[i].style,{
        //         '-webkit-transition':'500ms opacity ' + 1000 * (i+1) +'ms ease-out',
        //         '-moz-transition':'500ms opacity ' + 1000 * (i+1) +'ms ease-out',
        //         '-ms-transition':'500ms opacity ' + 1000 * (i+1) +'ms ease-out',
        //         '-o-transition':'500ms opacity ' + 1000 * (i+1) +'ms ease-out',
        //         'transition':'500ms opacity ' + 1000 * (i+1) +'ms ease-out'
        //     });       
        //     characters[i].classList.toggle('hidden');
        // }
        // setTimeout(()=>{
        //     let className = this.state.className;
        //     className += ' hidden';
        //     this.setState({className});
        // },timetoShow);

        let automaticAnswer = this.state.automaticAnswer;
        // setTimeout(()=>{
        //     automaticAnswer = true;
        //     this.setState({automaticAnswer});
        // },timeOut);

    }

    componentWillUnmount(){
        document.removeEventListener("keydown", this.showChar);
        document.removeEventListener("keypress", this.addListeners);
    }

    updateAutomatic = () =>{
        let automaticAnswer = true;
        this.setState({automaticAnswer});
    }

    showChar = (e) =>{
        let startTime = new Date();
        this.setState({startTime});
        if (e.keyCode === 32) {
            document.querySelector('.symbol-holder').innerHTML = this.state.symbol;
            setTimeout(function(){
                document.querySelector('.nineth-test .symbol-holder').innerHTML = '';
                document.querySelector('.testNineText').style.visibility = 'hidden';
            },500);
        }
    }

    addListeners = (e) =>{
        const {symbol, symbo2} = {...this.props}
        let realAnswer = symbo2.toString().includes(symbol.toString());
        let automaticAnswer = this.state.automaticAnswer;

        if(e.keyCode === 97 || e.keyCode === 49){
            this.props.fillAnswer(
                'Yes',
                this.state.startTime,
                realAnswer,
                automaticAnswer,
                symbol,
                symbo2,
            );
        }
        if(e.keyCode === 98 || e.keyCode === 50){
            this.props.fillAnswer(
                'No',
                this.state.startTime,
                realAnswer,
                automaticAnswer,
                symbol,
                symbo2,
            );
        }
    }

    render() {

        const {symbol, symbo2} = {...this.props}
        let realAnswer = symbo2.toString().includes(symbol.toString());
        let automaticAnswer = this.state.automaticAnswer;
        return (
            <React.Fragment>
                <div className={this.state.className} >
                    <div className="symbol-holder">
                        {/* <p className="symbol">{symbol}</p>
                        <p className="symbol">{symbo2}</p> */}
                        {/* {character} */}
                    </div>
                </div>
                <div className="buttons">
                    <button
                        className="answer-buttons"
                        onClick={() => {
                            this.props.fillAnswer(
                                'Yes',
                                this.state.startTime,
                                realAnswer,
                                automaticAnswer,
                                symbol,
                                symbo2,
                            );
                        }}
                    >
                        დიახ
                    </button>
                    <button
                        className="answer-buttons"
                        onClick={() => {
                            this.props.fillAnswer(
                                'No',
                                this.state.startTime,
                                realAnswer,
                                automaticAnswer,
                                symbol,
                                symbo2,
                            );
                        }}
                    >
                        არა
                    </button>
                </div>
            </React.Fragment>
            
        );
    }
}

export default Question;